import React from 'react';
import { SelectInput } from '../BasicForm';
import { CertCheckbox } from '../CertCheckbox';
import SelectFieldOptions from '../../utils/selectFieldOptions';

export const MinorOffenderSelectionCard = (props) => (
	<li className="result-data">
		<CertCheckbox 
			name={props.checkName}
            value={props.checkVal}
            required="true"
            onChange={props.handleAddOffender}
            errMessage={props.checkErrMessage} />
		<dl className="general-info">
			<dt>name</dt>
			<dd className="body-bold">{props.fullName}&nbsp;&#47;&#47;&nbsp;</dd>
			<dt>age</dt>
			<dd className="body-bold">{props.age},&nbsp;</dd>
			<dt>race</dt>
			<dd className="body-bold">{props.race},&nbsp;</dd>
			<dt>sex</dt>
			<dd className="body-bold">{props.sex}</dd>
		</dl>
		<dl className="secondary-info">
			<div>
				<dt>Alias:&nbsp;</dt>
				<dd>{props.alias}</dd>
			</div>
			<div>
				<dt>Inmate ID #:&nbsp;</dt>
				<dd>{props.offenderId}</dd>
			</div>
			<div>
				<dt>Location:&nbsp;</dt>
				<dd>{props.locationName}</dd>
			</div>
			<div>
				<dt>Release Date:</dt>
				<dd>{props.projectedReleaseDate}</dd>
			</div>
		</dl>
		<SelectInput
			className={props.selectClassName}
			labelClassName={props.className}
			options={SelectFieldOptions.relationshipTypes}
			value={props.selectVal} 
			name={props.selectId}
			required={true}
			label="Inmate's Relationship to Minor"
			hint = "For example, if the inmate is the minor's father, select &#34father&#34 from the dropdown list." 
			disabled={props.selectDisabled} 
			onChange={props.setMinorOffenderRelationship}
			errMessage={props.selectErrMessage} />

	</li>
);


// WEBPACK FOOTER //
// ./src/components/MinorOffenderSelectionCard/MinorOffenderSelectionCard.js